(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('[data-nav-toggle]').forEach(function (toggle) {
    var header = toggle.closest('.site-header');
    if (!header) {
      return;
    }

    var closeButton = header.querySelector('[data-nav-close]');
    var mq = window.matchMedia('(min-width: 768px)');

    // Locks background scroll while the full-screen mobile overlay is
    // open — otherwise the page content underneath can still be scrolled
    // (e.g. via touch) despite being visually covered.
    function setNavOpen(open) {
      toggle.setAttribute('aria-expanded', String(open));
      header.setAttribute('data-nav-open', String(open));
      document.documentElement.classList.toggle('nav-open', open);
    }

    function closeNav() {
      setNavOpen(false);
    }

    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      var opening = !open;
      if (opening) {
        // Symmetric with the cart trigger closing the nav overlay first —
        // don't stack both overlays at once.
        var cartModal = document.querySelector('[data-cart-modal]');
        if (cartModal && cartModal.getAttribute('data-open') === 'true') {
          cartModal.setAttribute('data-open', 'false');
          document.documentElement.classList.remove('cart-open');
        }
      }
      setNavOpen(opening);
    });

    if (closeButton) {
      closeButton.addEventListener('click', function () {
        closeNav();
        toggle.focus();
      });
    }

    header.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        closeNav();
        toggle.focus();
      }
    });

    mq.addEventListener('change', function () {
      if (!mq.matches) {
        return;
      }
      closeNav();
    });
  });

  (function () {
    var header = document.querySelector('.site-header');
    if (!header) {
      return;
    }

    // Reserves space for the now-fixed header on every page except the
    // homepage (see the body:not(.template-index) rule above). Also used
    // below for the Spiral House wordmark's scroll-up hysteresis.
    var headerHeight = 0;
    function setHeaderHeightVar() {
      headerHeight = header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    }
    setHeaderHeightVar();
    window.addEventListener('load', setHeaderHeightVar);
    window.addEventListener('resize', setHeaderHeightVar);

    // Fades the header out on scroll-down, back in on scroll-up. Stays
    // visible near the top of the page so it doesn't flicker on tiny
    // scroll jitters right at load.
    var FADE_THRESHOLD = 24;
    var lastScrollY = window.scrollY;
    var ticking = false;

    // Homepage only: swap the wordmark once scroll reaches the Spiral
    // House hero. Absent on every other page, so this is naturally a
    // no-op there. Scrolling back up uses a different (earlier) threshold
    // than scrolling down (hysteresis): it swaps to Spiral House as soon
    // as the hero's top edge reaches the top of the viewport, but swaps
    // back to Silver Press only once that same edge has scrolled down
    // past the *bottom* of the header — i.e. the hero top has fully
    // reappeared below the header, not just started to.
    var spiralHouseHero = document.querySelector('[data-imprint-hero="spiral_house"]');
    var spiralHouseTop = null;
    var isSpiralHouseActive = false;
    var wasSpiralHouseActive = false;
    var revealLockTimeout = null;
    var REVEAL_LOCK_MS = 1200;

    // Real scroll gestures don't stop exactly on the crossing pixel —
    // momentum carries a little further, re-triggering the fade-down
    // branch a frame or two after the crossing reset it. So "are they
    // still actively scrolling" is tracked independently via idle
    // detection, and checked when the reveal lock expires (below) rather
    // than trusting whatever is-faded happened to be re-set to in transit.
    var isScrolling = false;
    var scrollIdleTimeout = null;
    var SCROLL_IDLE_MS = 150;

    function markScrolling() {
      isScrolling = true;
      if (scrollIdleTimeout) {
        clearTimeout(scrollIdleTimeout);
      }
      scrollIdleTimeout = setTimeout(function () {
        isScrolling = false;
      }, SCROLL_IDLE_MS);
    }

    function setSpiralHouseTop() {
      if (spiralHouseHero) {
        spiralHouseTop = spiralHouseHero.getBoundingClientRect().top + window.scrollY;
        isSpiralHouseActive = window.scrollY >= spiralHouseTop;
        wasSpiralHouseActive = isSpiralHouseActive;
      }
    }
    setSpiralHouseTop();
    window.addEventListener('load', setSpiralHouseTop);
    window.addEventListener('resize', setSpiralHouseTop);

    function onScroll() {
      var currentScrollY = window.scrollY;

      if (currentScrollY <= FADE_THRESHOLD) {
        header.classList.remove('is-faded');
      } else if (currentScrollY > lastScrollY) {
        header.classList.add('is-faded');
      } else if (currentScrollY < lastScrollY) {
        header.classList.remove('is-faded');
      }

      if (spiralHouseTop !== null) {
        if (!isSpiralHouseActive && currentScrollY >= spiralHouseTop) {
          isSpiralHouseActive = true;
        } else if (isSpiralHouseActive && currentScrollY < spiralHouseTop - headerHeight) {
          isSpiralHouseActive = false;
        }
        header.classList.toggle('is-spiral-house', isSpiralHouseActive);

        // Reaching the Spiral House hero holds the header visible for a
        // beat (even mid scroll-down) so the wordmark swap is actually
        // seen. A single-frame reveal isn't enough: with continuous
        // scroll events firing every few pixels, the very next one (still
        // net scrolling down) would re-trigger the fade-down logic before
        // the opacity transition even finished, so it never reads as
        // visible. is-reveal-lock only holds the *visual* fade off for a
        // fixed window; is-faded is also explicitly cleared right here so
        // that if the user stops scrolling during or right after that
        // window, there's no stale "was scrolling down" state left to
        // fade it out once the lock lifts — it only fades again once a
        // later scroll event actually re-adds is-faded, i.e. once they
        // genuinely resume scrolling down.
        if (isSpiralHouseActive && !wasSpiralHouseActive) {
          header.classList.remove('is-faded');
          header.classList.add('is-reveal-lock');
          if (revealLockTimeout) {
            clearTimeout(revealLockTimeout);
          }
          revealLockTimeout = setTimeout(function () {
            header.classList.remove('is-reveal-lock');
            // If they'd stopped scrolling by the time the hold ends, don't
            // let a trailing/momentum down-scroll from right after the
            // crossing fade it out anyway — only an actual resumed
            // scroll-down, after this point, should do that.
            if (!isScrolling) {
              header.classList.remove('is-faded');
            }
          }, REVEAL_LOCK_MS);
        }
        wasSpiralHouseActive = isSpiralHouseActive;
      }

      lastScrollY = currentScrollY;
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        markScrolling();
        if (!ticking) {
          window.requestAnimationFrame(onScroll);
          ticking = true;
        }
      },
      { passive: true }
    );
  })();

  // <cart-items> itself — defined here (not in sections/cart.liquid) since
  // this section renders globally and that one only renders on /cart, but
  // this custom element also needs to work inside the cart modal below on
  // every other page. Shopify only ships a section's own inline scripts on
  // pages where that section actually renders, so putting the definition
  // in cart.liquid would leave it undefined everywhere else.
  class CartItems extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));

      // Fades the list's own bottom edge via a data attribute the modal's
      // CSS turns into a mask-image — hints there's more to scroll without
      // a fixed pixel guess, since it's driven by the list's real scroll
      // position rather than an assumed viewport/item size. No-op on the
      // standalone /cart page, where .cart__list is never a scroll
      // container in the first place (scrollHeight === clientHeight there).
      var list = this.querySelector('.cart__list');
      if (list) {
        var updateListFade = function () {
          var hasMore = list.scrollHeight - list.scrollTop - list.clientHeight > 1;
          list.setAttribute('data-more-below', hasMore ? 'true' : 'false');
        };
        list.addEventListener('scroll', updateListFade);
        window.addEventListener('resize', updateListFade);
        updateListFade();
        this.removeListFadeResizeListener = function () {
          window.removeEventListener('resize', updateListFade);
        };
      }
    }

    disconnectedCallback() {
      if (this.removeListFadeResizeListener) {
        this.removeListFadeResizeListener();
      }
    }

    handleClick(event) {
      var decreaseBtn = event.target.closest('[data-cart-quantity-decrease]');
      var increaseBtn = event.target.closest('[data-cart-quantity-increase]');
      var removeLink = event.target.closest('[data-cart-remove]');

      if (decreaseBtn || increaseBtn) {
        event.preventDefault();
        var stepLine = (decreaseBtn || increaseBtn).closest('[data-cart-line]');
        var valueEl = stepLine.querySelector('[data-cart-quantity-value]');
        var current = parseInt(valueEl.textContent, 10) || 0;
        var next = decreaseBtn ? Math.max(0, current - 1) : current + 1;
        this.changeLine(stepLine.dataset.cartLine, next);
      } else if (removeLink) {
        event.preventDefault();
        var removeItem = removeLink.closest('[data-cart-line]');
        this.changeLine(removeItem.dataset.cartLine, 0);
      }
    }

    // Re-fetches the real rendered page after any change rather than
    // patching quantities/prices/totals by hand in JS — .final_line_price
    // and .total_price go through Liquid's money filter (locale-aware
    // formatting this theme doesn't otherwise need in JS), and a line can
    // disappear entirely at quantity 0, which is much simpler to get right
    // from a fresh server render than to reproduce client-side.
    changeLine(line, quantity) {
      var cartUrl = this.dataset.cartUrl || '/cart';

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function () {
          return fetch(cartUrl);
        })
        .then(function (response) {
          return response.text();
        })
        .then(function (text) {
          var wrapper = document.createElement('div');
          wrapper.innerHTML = text;
          var fresh = wrapper.querySelector('cart-items');
          if (!fresh) {
            return;
          }
          // Every mounted copy (the real page's own, and/or the header's
          // modal, if either is currently present) gets replaced — a fresh
          // <cart-items> tag re-triggers connectedCallback automatically.
          document.querySelectorAll('cart-items').forEach(function (el) {
            el.outerHTML = fresh.outerHTML;
          });
          document.dispatchEvent(new CustomEvent('cart:updated'));
        });
    }
  }

  customElements.define('cart-items', CartItems);

  // In-page cart modal: intercepts the "My cart" link (desktop nav and the
  // mobile nav-overlay share this same element, so this covers both),
  // fetches sections/cart.liquid's own markup via the Section Rendering
  // API, and drops it straight into the modal — no separate template to
  // maintain, the page and the modal are always the same markup.
  (function () {
    var trigger = document.querySelector('[data-cart-trigger]');
    var modal = document.querySelector('[data-cart-modal]');
    if (!trigger || !modal) {
      return;
    }

    var closeButton = modal.querySelector('[data-cart-modal-close]');
    var content = modal.querySelector('[data-cart-modal-content]');
    var cartUrl = trigger.getAttribute('href');
    var header = trigger.closest('.site-header');

    function setCartOpen(open) {
      modal.setAttribute('data-open', String(open));
      document.documentElement.classList.toggle('cart-open', open);
    }

    function closeCart() {
      setCartOpen(false);
    }

    // Always current, not just on first open — cheap, and guarantees the
    // modal never shows stale quantities/totals from before it was opened.
    function loadCartContent() {
      fetch(cartUrl)
        .then(function (response) {
          return response.text();
        })
        .then(function (text) {
          var wrapper = document.createElement('div');
          wrapper.innerHTML = text;
          var fresh = wrapper.querySelector('cart-items');
          if (!fresh) {
            return;
          }
          content.innerHTML = '';
          content.appendChild(fresh);
        });
    }

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      // If the mobile nav overlay is what's currently open (this same link
      // also lives inside it), close it first rather than stacking both
      // overlays at once. Also resets the hamburger's own aria-expanded —
      // leaving it stale at "true" here (while data-nav-open correctly
      // went back to "false") made the toggle's click handler think it
      // was still open, so the next click closed it again (visually a
      // no-op, since it was already closed) and only the click after that
      // actually reopened it.
      if (header && header.getAttribute('data-nav-open') === 'true') {
        header.setAttribute('data-nav-open', 'false');
        document.documentElement.classList.remove('nav-open');
        var navToggle = header.querySelector('[data-nav-toggle]');
        if (navToggle) {
          navToggle.setAttribute('aria-expanded', 'false');
        }
      }
      setCartOpen(true);
      loadCartContent();
    });

    closeButton.addEventListener('click', function () {
      closeCart();
      trigger.focus();
    });

    modal.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeCart();
        trigger.focus();
      }
    });

    // Covers both: an add-to-cart elsewhere on the page while the modal is
    // open, and a quantity/remove change made inside the modal itself
    // (sections/cart.liquid's own <cart-items> already updates the DOM
    // directly for that case, so this is a harmless extra refresh, not the
    // only thing keeping it correct).
    document.addEventListener('cart:updated', function () {
      if (modal.getAttribute('data-open') === 'true') {
        loadCartContent();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      var url = this.dataset.url;
      if (!url) {
        return;
      }

      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then((function (text) {
          var wrapper = document.createElement('div');
          wrapper.innerHTML = text;

          var content = wrapper.querySelector('product-recommendations');
          if (content && content.innerHTML.trim().length) {
            this.innerHTML = content.innerHTML;
          } else {
            this.remove();
          }
        }).bind(this))
        .catch(function () {});
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('.product__cta').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var button = form.querySelector('.link-cart');
      var variantId = form.querySelector('input[name="id"]').value;
      var originalLabel = button.textContent;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (response) {
          return response.json();
        })
        .then(function () {
          button.textContent = button.dataset.addedLabel || originalLabel;
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function () {
            button.textContent = originalLabel;
          }, 1500);
        });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
